module.exports = __webpack_public_path__ + "img/uniads.logo@2x.e688c846.png";